import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/image/logo_login.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "login-container row" }
const _hoisted_5 = { class: "login-wrap card col-md-5 m-auto" }
const _hoisted_6 = { class: "align-items-center py-5" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-9 mx-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "login-content d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"height":"inherit"}
  })
], -1)
const _hoisted_10 = { class: "text-center mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "text-center text-danger mb-3"
}
const _hoisted_13 = { class: "row mb-4" }
const _hoisted_14 = { class: "col-md-9 mx-auto required" }
const _hoisted_15 = { class: "row mb-4" }
const _hoisted_16 = { class: "col-md-9 mx-auto required" }
const _hoisted_17 = { class: "row mb-4" }
const _hoisted_18 = { class: "col-md-9 d-flex mx-auto" }
const _hoisted_19 = { class: "col-md-12 d-grid shadow" }
const _hoisted_20 = { class: "row mb-4" }
const _hoisted_21 = { class: "row col-md-9 mx-auto" }
const _hoisted_22 = { class: "col-md-6 ps-0 pe-0 login-remember-me" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "binary" }, "Keep Login (8HR)", -1)
const _hoisted_25 = { class: "col-md-6 ps-0 pe-0" }
const _hoisted_26 = { class: "border-top" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "my-3" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Set up two-factor authentication.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "my-2" }, [
      /*#__PURE__*/_createElementVNode("p", null, "To be able to authorize transactions, you need to scan this QR Code with your Cisco Duo Authentication App and verify your identity.")
    ])
  ])
], -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = {
  class: "d-flex justify-content-center",
  style: {"border":"1px solid lightgrey"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-12 d-flex justify-content-center" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-3" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Please approve this login session with your Cisco Duo Authentication App on the registered device to verify your identity.")
  ])
], -1)
const _hoisted_38 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_39 = { class: "my-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNotice = _resolveComponent("TheNotice")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheNotice),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("h3", _hoisted_10, [
                      _createTextVNode("BERJAYA FINANCE - RPK "),
                      _hoisted_11,
                      (_ctx.envMode != null && _ctx.envMode != '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "[" + _toDisplayString(_ctx.envMode) + "]", 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_InputText, {
                      class: "p-inputtext",
                      type: "text",
                      maxlength: "50",
                      placeholder: "Email Address",
                      modelValue: _ctx.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_InputText, {
                      class: "p-inputtext",
                      type: "password",
                      maxlength: "50",
                      placeholder: "Password",
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Button, {
                        class: "p-button-lg text-uppercase",
                        onClick: _ctx.login,
                        disabled: _ctx.v$.$invalid || _ctx.isLoading,
                        label: "Sign in"
                      }, null, 8, ["onClick", "disabled"])
                    ]),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_Checkbox, {
                        modelValue: _ctx.rememberMe,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event)),
                        binary: true
                      }, null, 8, ["modelValue"]),
                      _hoisted_23,
                      _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_Button, {
                        class: "p-button-link float-end pe-0",
                        label: "Forgot Password",
                        onClick: _ctx.forgotPassword
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_TheFooter, { hideCompany: true })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "Two Factor Authentication",
      visible: _ctx.auth2FADialog.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.auth2FADialog.visible) = $event)),
      draggable: false,
      style: {width:'30vw'},
      onHide: _ctx.cancelAuth2FA
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          (_ctx.auth2FADialog.auth2FADetail.result == 'enroll')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        src: _ctx.auth2FADialog.auth2FADetail.activation_barcode,
                        alt: "activationCode",
                        style: {"width":"150px"}
                      }, null, 8, _hoisted_32)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Button, {
                      class: "p-button-link float-end pe-0",
                      label: "Not yet registered? Click here",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enroll2FA(_ctx.auth2FADialog.auth2FADetail.activation_url)))
                    })
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  (_ctx.auth2FADialog.loading)
                    ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_ctx.auth2FADialog.errorMessage != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_InlineMessage, { severity: "error" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.auth2FADialog.errorMessage), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}